<div *ngIf="node.visible !== false" class="tree-element" [style.--depth]="depth">
    <span class="tree-col caption" (click)="disableDeselection ? '' : onToggleSelect()">
        <!-- Selection Checkbox -->
        <span
            *ngIf="node.selected"
            class="ham-icon"
            (click)="disableDeselection ? '' : onToggleSelect()"
            stopPropagation
        >
            <i class="checkbox-checked-icon"></i>
        </span>
        <span *ngIf="!node.selected" class="ham-icon" (click)="onToggleSelect()" stopPropagation>
            <i class="checkbox-empty-icon"></i>
        </span>
        <span
            *ngIf="node.children?.length && !node.expanded"
            hamIconShapes
            icon="assets/hamIcons/chevron-up-outline.svg"
            [variant]="'hamed'"
            [size]="'xs'"
            [type]="'circle'"
            (click)="toggleExpand()"
        ></span>
        <span
            *ngIf="node.children?.length && node.expanded"
            hamIconShapes
            icon="assets/hamIcons/chevron-down.svg"
            [variant]="'hamed'"
            [size]="'xs'"
            [type]="'circle'"
            (click)="toggleExpand()"
        ></span>
        <span
            class="text"
            data-testid="mapping-item-label"
            [hamTooltip]="label"
            [tooltipOnlyWhenTruncated]="true"
            [tooltipAboveModals]="true"
        >
            {{ label }}
        </span>
    </span>
    <!-- REV-20899: displayed values include the aggregated transactional reclass. -->
    <span class="tree-col current-year">{{ currentValue | finNumber }}</span>
    <span class="tree-col previous-year">{{ previousValue | finNumber }}</span>
</div>

<div class="children" *ngIf="node.expanded" [ngClass]="{ expanded: node.expanded }">
    <ng-container *ngFor="let child of node.children">
        <mapping-items-tree-node
            [node]="child"
            [depth]="depth + 1"
            [disableDeselection]="node.selected"
            (toggleSelect)="toggleSelect.emit($event)"
        ></mapping-items-tree-node>
    </ng-container>
</div>
